import { all, fork } from 'redux-saga/effects'

import { rootSaga as address } from './addressSaga'
import { rootSaga as audit } from './auditSaga'
import { rootSaga as jobs } from './jobs'
import { rootSaga as jobDetails } from './jobDetails'
import { rootSaga as dobAttachment } from './jobFunctions/dobAttachmentSaga'
import { rootSaga as dobNote } from './jobFunctions/dobNoteSaga'
import { rootSaga as jobFinancialSummary } from './jobFunctions/jobFinancialSummarySaga'
import { rootSaga as jobAia } from './jobFunctions/jobAiaSaga'
import { rootSaga as jobAttachment } from './jobFunctions/jobAttachmentSaga'
import { rootSaga as jobContact } from './jobFunctions/jobContactSaga'
import { rootSaga as jobDrawing } from './jobFunctions/jobDrawingSaga'
import { rootSaga as jobFollowUp } from './jobFunctions/jobFollowUpSaga'
import { rootSaga as jobEstimate } from './jobFunctions/jobEstimateSaga'
import { rootSaga as jobInvoice } from './jobFunctions/jobInvoiceSaga'
import { rootSaga as jobNote } from './jobFunctions/jobNoteSaga'
import { rootSaga as jobStopCall } from './jobFunctions/jobStopCallSaga'
import { rootSaga as jobPaymentRequest } from './jobFunctions/jobPaymentRequestSaga'
import { rootSaga as jobSiteChangeOrder } from './jobFunctions/jobSiteChangeOrderSaga'
import { rootSaga as jobSiteDocument } from './jobFunctions/jobSiteDocumentSaga'
import { rootSaga as jobSiteDriverRequest } from './jobFunctions/jobSiteDriverRequestSaga'
import { rootSaga as jobSiteEstimate } from './jobFunctions/jobSiteEstimateSaga'
import { rootSaga as jobSiteJobMinute } from './jobFunctions/jobSiteJobMinuteSaga'
import { rootSaga as jobSiteMaterialRequest } from './jobFunctions/jobSiteMaterialRequestSaga'
import { rootSaga as jobSiteOverview } from './jobFunctions/jobSiteOverviewSaga'
import { rootSaga as jobSitePurchaseOrder } from './jobFunctions/jobSitePurchaseOrderSaga'
import { rootSaga as jobSiteRFI } from './jobFunctions/jobSiteRFISaga'
import { rootSaga as jobSiteTransmittal } from './jobFunctions/jobSiteTransmittalSaga'
import { rootSaga as jobSiteWorkOrder } from './jobFunctions/jobSiteWorkOrderSaga'
import { rootSaga as jobSiteServiceOrder } from './jobFunctions/jobSiteServiceOrderSaga'
import { rootSaga as jobVendor } from './jobFunctions/jobVendorSaga'
import { rootSaga as scheduleApplication } from './jobFunctions/scheduleApplicationSaga'
import { rootSaga as scheduleSiteWork } from './jobFunctions/scheduleSiteWorkSaga'
import { rootSaga as violation } from './jobFunctions/violationSaga'
import { rootSaga as scheduleDrawing } from './jobFunctions/scheduleDrawingSaga'
import { rootSaga as scheduleRepair } from './jobFunctions/scheduleRepairSaga'
import { rootSaga as scheduleManufacturing } from './jobFunctions/scheduleManufacturingSaga'
import { rootSaga as purchaseOrder } from './jobFunctions/purchaseOrderSaga'
import { rootSaga as estimateTemplate } from './jobFunctions/estimateTemplateSaga'
import { rootSaga as workOrderTemplate } from './jobFunctions/workOrderTemplateSaga'
import { rootSaga as materialRequestTemplate } from './jobFunctions/materialRequestTemplateSaga'
import { rootSaga as driverRequestTemplate } from './jobFunctions/driverRequestTemplateSaga'
import { rootSaga as jobPart } from './jobFunctions/jobPartSaga'
import { rootSaga as user } from './userSaga'
import { rootSaga as items } from './itemsSaga'
import { rootSaga as leads } from './leadsSaga'
import { rootSaga as leadDetails } from './leadDetails'
import { rootSaga as leadAttachment } from './leadFunctions/leadAttachmentSaga'
import { rootSaga as leadContact } from './leadFunctions/leadContactSaga'
import { rootSaga as leadEstimate } from './leadFunctions/leadEstimateSaga'
import { rootSaga as leadProposal } from './leadFunctions/leadProposalSaga'
import { rootSaga as leadContract } from './leadFunctions/leadContractSaga'
import { rootSaga as leadFollowUp } from './leadFunctions/leadFollowUpSaga'
import { rootSaga as leadNote } from './leadFunctions/leadNoteSaga'
import { rootSaga as leadRFI } from './leadFunctions/leadRFISaga'
import { rootSaga as leadTransmittal } from './leadFunctions/leadTransmittalSaga'
import { rootSaga as proposalTemplate } from './leadFunctions/proposalTemplateSaga'
import { rootSaga as contractTemplate } from './leadFunctions/contractTemplateSaga'
import { rootSaga as companies } from './companiesSaga'
import { rootSaga as vendor } from './vendorsSaga'
import { rootSaga as contact } from './contactsSaga'
import { rootSaga as employee } from './employeesSaga'
import { rootSaga as task } from './tasksSaga'
import { rootSaga as help } from './helpSaga'
import { rootSaga as driverRequest } from './driverRequestSaga'
import { rootSaga as driver } from './driverSaga'
import { rootSaga as vehicles } from './vehiclesSaga'
import { rootSaga as users } from './usersSaga'
import { rootSaga as template } from './templatesSaga'
import { rootSaga as organizations } from './organizationsSaga'
import { rootSaga as jobAgreement } from './jobFunctions/jobAgreementSaga'
import { rootSaga as jobSiteTicket } from './jobFunctions/jobSiteTicketSaga'
import { rootSaga as proposal } from './proposalSaga'
import { rootSaga as contract } from './contractSaga'
import { rootSaga as serviceOrderTemplate } from './jobFunctions/serviceOrderTemplateSaga'
import { rootSaga as dashboard } from './dashboard/dashboardSaga'
import { rootSaga as activityReport } from './reports/general/activityReportSaga'
import { rootSaga as openItemsReport } from './reports/general/openItemsReportSaga'
import { rootSaga as purchaseOrdersReport } from './reports/general/purchaseOrdersReportSaga'
import { rootSaga as toolsReport } from './reports/general/toolsReportSaga'
import { rootSaga as scheduleReport } from './reports/general/scheduleReportSaga'
import { rootSaga as jobMinutesReport } from './reports/general/jobMinutesReportSaga'
import { rootSaga as aiasReport } from './reports/financial/aiasReportSaga'
import { rootSaga as maintenanceFinancialsReport } from './reports/financial/maintenanceFinancialsReportSaga'
import { rootSaga as paymentRequestReport } from './reports/financial/paymentRequestReportSaga'
import { rootSaga as invoicesReport } from './reports/financial/invoicesReportSaga'
import { rootSaga as activeJobContractsReport } from './reports/financial/activeJobContractsReportSaga'
import { rootSaga as leadsReport } from './reports/leads/leadsReportSaga'
import { rootSaga as proposalsSent } from './reports/leads/proposalsSentSaga'
import { rootSaga as contractsSent } from './reports/leads/contractsSentSaga'
import { rootSaga as jobsReport } from './reports/jobs/jobsReportSaga'
import { rootSaga as drawingsReport } from './reports/jobs/drawingsReportSaga'
import { rootSaga as confirmedShipmentDatesReport } from './reports/jobs/confirmedShipmentDatesSaga'
import { rootSaga as transmittalsReport } from './reports/jobs/transmittalsReportSaga'
import { rootSaga as rfisReport } from './reports/jobs/rfisReportSaga'
import { rootSaga as siteWorkSchedulesReport } from './reports/jobs/siteWorkSchedulesReportSaga'
import { rootSaga as manufacturingScheduleReport } from './reports/jobs/manufacturingScheduleReportSaga'
import { rootSaga as drawingSchedulesReport } from './reports/jobs/drawingSchedulesReportSaga'
import { rootSaga as changeOrdersReport } from './reports/jobs/changeOrdersReportSaga'
import { rootSaga as financialSchedulesReport } from './reports/jobs/financialSchedulesReportSaga'
import { rootSaga as stopCallsReport } from './reports/maintenance_dob/stopCallsReportSaga'
import { rootSaga as violationsReport } from './reports/maintenance_dob/violationsReportSaga'
import { rootSaga as targetedMonthlyVisitsReport } from './reports/maintenance_dob/targetedMonthlyVisitsReportSaga'
import { rootSaga as applicationSchedulesReport } from './reports/maintenance_dob/applicationSchedulesReportSaga'
import { rootSaga as maintenanceSchedulesReport } from './reports/maintenance_dob/maintenanceSchedulesReportSaga'
import { rootSaga as ticketsReport } from './reports/maintenance_dob/ticketsReportSaga'
import { rootSaga as revision } from './revisionSaga'
import { rootSaga as jobSiteRepairOrders } from './jobFunctions/jobSiteRepairOrderSaga'
import { rootSaga as scheduledDeliveries } from './scheduledDeliveriesSaga'
import { rootSaga as testing } from './jobFunctions/testingSaga'

import { rootSaga as authentication } from './authentication'

function* rootSaga() {
  yield all([
    fork(address),
    fork(audit),
    fork(jobs),
    fork(jobDetails),
    fork(dobAttachment),
    fork(dobNote),
    fork(jobFinancialSummary),
    fork(jobAia),
    fork(jobAttachment),
    fork(jobContact),
    fork(jobDrawing),
    fork(jobFollowUp),
    fork(jobEstimate),
    fork(jobInvoice),
    fork(jobNote),
    fork(jobStopCall),
    fork(jobPaymentRequest),
    fork(jobSiteChangeOrder),
    fork(jobSiteDocument),
    fork(jobSiteDriverRequest),
    fork(jobSiteEstimate),
    fork(jobSiteJobMinute),
    fork(jobSiteMaterialRequest),
    fork(jobSiteOverview),
    fork(jobSitePurchaseOrder),
    fork(jobSiteRFI),
    fork(jobSiteTransmittal),
    fork(jobSiteWorkOrder),
    fork(jobVendor),
    fork(scheduleApplication),
    fork(scheduleDrawing),
    fork(scheduleManufacturing),
    fork(scheduleSiteWork),
    fork(scheduleRepair),
    fork(violation),
    fork(purchaseOrder),
    fork(estimateTemplate),
    fork(driverRequestTemplate),
    fork(materialRequestTemplate),
    fork(user),
    fork(items),
    fork(leads),
    fork(leadDetails),
    fork(leadAttachment),
    fork(leadContact),
    fork(leadEstimate),
    fork(leadProposal),
    fork(leadContract),
    fork(proposalTemplate),
    fork(contractTemplate),
    fork(leadFollowUp),
    fork(leadNote),
    fork(leadRFI),
    fork(leadTransmittal),
    fork(companies),
    fork(vendor),
    fork(contact),
    fork(employee),
    fork(task),
    fork(help),
    fork(driverRequest),
    fork(driver),
    fork(vehicles),
    fork(users),
    fork(template),
    fork(workOrderTemplate),
    fork(jobPart),
    fork(organizations),
    fork(jobAgreement),
    fork(authentication),
    fork(jobSiteTicket),
    fork(contract),
    fork(proposal),
    fork(jobSiteServiceOrder),
    fork(serviceOrderTemplate),
    fork(dashboard),
    fork(activityReport),
    fork(openItemsReport),
    fork(purchaseOrdersReport),
    fork(jobMinutesReport),
    fork(toolsReport),
    fork(scheduleReport),
    fork(aiasReport),
    fork(maintenanceFinancialsReport),
    fork(paymentRequestReport),
    fork(invoicesReport),
    fork(activeJobContractsReport),
    fork(leadsReport),
    fork(proposalsSent),
    fork(contractsSent),
    fork(jobsReport),
    fork(drawingsReport),
    fork(confirmedShipmentDatesReport),
    fork(transmittalsReport),
    fork(rfisReport),
    fork(siteWorkSchedulesReport),
    fork(manufacturingScheduleReport),
    fork(drawingSchedulesReport),
    fork(changeOrdersReport),
    fork(financialSchedulesReport),
    fork(stopCallsReport),
    fork(violationsReport),
    fork(targetedMonthlyVisitsReport),
    fork(applicationSchedulesReport),
    fork(maintenanceSchedulesReport),
    fork(ticketsReport),
    fork(revision),
    fork(jobSiteRepairOrders),
    fork(scheduledDeliveries),
    fork(testing)
  ])
}

export default rootSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js